export default "__VITE_ASSET__Tk3cKcIR8tYJqQz5l73v2A__ 480w, __VITE_ASSET__NHJ6QB3ZVMf35ip30RyL0A__ 745w";